import * as React from 'react';
import { getPaymentSelectOptions } from '../../../utils/get-payment-select-options.js';
import { IdealContainer } from '../../../containers/Adyen/Ideal/containers/IdealContainer.js';

const Ideal = ({ config , onChange  })=>{
    const selectItems = React.useMemo(()=>getPaymentSelectOptions(config)
    , [
        config
    ]);
    const onHandleChange = React.useCallback((selectedBank)=>{
        if (selectedBank.label && selectedBank.value) {
            onChange({
                issuerId: selectedBank.value
            }, true);
        } else {
            onChange({}, false);
        }
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(IdealContainer, {
        items: selectItems,
        onChange: onHandleChange
    });
};

export { Ideal };
//# sourceMappingURL=Ideal.js.map
